'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _reactBootstrap = require('react-bootstrap');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {bindActionCreators} from 'redux';
// import {connect} from 'react-redux';
// import {setUiProps} from 'redux/modules/info';


// jak tvorit dialogy
// https://react-bootstrap.github.io/components.html#modals

// @connect(
//   state => ({info: state.info.data}), // info nese informace o panelech (zatim spatne pojmenovane)
//   dispatch => bindActionCreators({}, dispatch))
var Window = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Window, _Component);

  function Window() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Window);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Window.__proto__ || (0, _getPrototypeOf2.default)(Window)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      // const {info, setUiProps, title} = this.props; // eslint-disable-line no-shadow
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          title = _this$props.title,
          okBtnText = _this$props.okBtnText,
          onNoClick = _this$props.onNoClick,
          okNoText = _this$props.okNoText; // eslint-disable-line no-shadow
      // const close = ()=>{setUiProps({name: 'showWindow', value: false});};
      // const close = ()=>{setUiProps({name: 'showWindow', value: false});};

      var show = true;
      // const show = info.ui['showWindow' + ''] ? true : false;
      // const subItemId = this.props.params.subItemId;
      // const styles = require('./Window.scss');
      // require the logo image both from client and server
      // const logoImage = require('./logo.png');
      var secondButton = onNoClick ? _react2.default.createElement(
        _reactBootstrap.Button,
        { bsStyle: 'primary', onClick: onNoClick },
        okNoText || 'NO'
      ) : null;
      var firstButton = onClick ? _react2.default.createElement(
        _reactBootstrap.Button,
        { bsStyle: 'primary', onClick: onClick },
        okBtnText || 'OK'
      ) : null;

      return _react2.default.createElement(
        'div',
        { className: 'static-modal noPrint' },
        _react2.default.createElement(
          _reactBootstrap.Modal,
          { bsSize: 'large', show: show, onHide: function onHide() {} },
          _react2.default.createElement(
            _reactBootstrap.Modal.Header,
            null,
            _react2.default.createElement(
              _reactBootstrap.Modal.Title,
              null,
              title || 'Dialog'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Body,
            null,
            _this.props.children
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            secondButton,
            firstButton
          )
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  return Window;
}(_react.Component), _class.propTypes = {
  // info: PropTypes.object,
  // setUiProps: PropTypes.func.isRequired,
  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react2.default.PropTypes.node), _react.PropTypes.node]),
  title: _react.PropTypes.string,
  onClick: _react.PropTypes.func,
  okBtnText: _react.PropTypes.string,
  onNoClick: _react.PropTypes.func,
  okNoText: _react.PropTypes.string

}, _temp2);

// class BootstrapWindow extends Window {
//   static defaultProps = assign({}, Window.defaultProps, {
//     close: <RB.Glyphicon {...this.props} glyph="remove" />,
//     restore: <RB.Glyphicon {...this.props} glyph="resize-small" />,
//     maximize: <RB.Glyphicon {...this.props} glyph="resize-full" />
//   });
// }

// class BootstrapModal extends Modal {
//   static defaultProps = assign({}, Modal.defaultProps, {
//     Window: BootstrapWindow,
//     footer: [
//       <RB.Button
//             key="Cancel"
//             bsStyle="default"
//         >Cancel</RB.Button>,
//       <RB.Button
//             key="Confirm"
//             bsStyle="primary"
//             >Confirm</RB.Button>
//     ]
//   });
// }

// class BootstrapConfirm extends Confirm {
//     static defaultProps = assign({}, Modal.defaultProps, {
//       Window: BootstrapWindow,
//       sign: <RB.Glyphicon glyph="question-sign"/>,
//       cancel: <RB.Button bsStyle="default">Cancel</RB.Button>,
//       ok: <RB.Button bsStyle="primary">OK</RB.Button>
//     });
// }

// class BootstrapTip extends Tip {
//   static defaultProps = assign({}, Modal.defaultProps, {
//     Window: BootstrapWindow,
//     sign: {
//       info: <RB.Glyphicon glyph="info-sign"/>,
//       success: <RB.Glyphicon glyph="ok-sign"/>,
//       warning: <RB.Glyphicon glyph="exclamation-sign"/>,
//       danger: <RB.Glyphicon glyph="remove-sign"/>
//     },
//     cancel: <RB.Button bsStyle="default">Cancel</RB.Button>,
//     ok: <RB.Button bsStyle="primary">OK</RB.Button>
//   });
// }

// export default {
//   Window: BootstrapWindow,
//   Modal: BootstrapModal,
//   Confirm: BootstrapConfirm,
//   Tip: BootstrapTip
// };

exports.default = Window;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Window/Window.js
// module id = 1202
// module chunks = 0